import { Pipe, PipeTransform } from '@angular/core';
import { environment } from 'src/environments/environment';

@Pipe({
  name: 'cdnBaseUrl'
})
export class CdnBaseUrlPipe implements PipeTransform {
  transform(value: unknown, ...args: unknown[]): unknown {
    const cdnBaseUrl = environment.cdnBaseUrl
    if (value) {
      return cdnBaseUrl + value
    }
    else {
      return ''
    }
  }

}
